import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { OpenCreateNewTagDialog } from '../actions/create-new-tag.actions';
import { CloseSidenav, OpenSidenav } from '../actions/sidenav.actions';
import { OpenUpdateTagDialog } from '../actions/update-tag.actions';
import { SideNavState } from '../models/search-filters.model';

const initialState: SideNavState = {
  sidenavStatus: false,
  createNewTag: false,
  updateTag: false,
};

export const SideNavReducer = createReducer(
  initialState,
  on(OpenSidenav, (state) => ({
    ...state,
    sidenavStatus: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    sidenavStatus: false,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    sidenavStatus: false,
  })),
  on(OpenCreateNewTagDialog, (state) => ({
    ...state,
    createNewTag: true,
    updateTag: false,
  })),
  on(OpenUpdateTagDialog, (state) => ({
    ...state,
    createNewTag: false,
    updateTag: true,
  }))
);
